import React from 'react'
import { Col, Row } from 'react-bootstrap'
import Icon from '../../component/Icon/Icon'

export const TransactionStatusItem = ({ title, icon, content }) => {
  return (
    <Col md={4} className="mt-1">
      <Row>
        <Col md={12} style={{color: '#818E9B'}}>{ title }</Col>
      </Row>
      <Row className="w-100">
        <Col md={1}>
          <Icon icon={`${icon} fa-lg`}  style={{color: '#666666'}}/>
        </Col>
        <Col md={10} style={{color: '#323C47'}}>
          { content }
        </Col>
      </Row>
    </Col>
  )
}




// WEBPACK FOOTER //
// ./src/component/Transaction/TransactionStatusItem.js